import React, { memo } from 'react';
import ReactCountryFlag from 'react-country-flag';

export const IconCountry = memo(({ size = 24, code, title }) => {
  return (
    <ReactCountryFlag
      countryCode={code}
      svg
      title={title}
      style={{ width: size }}
    />
  );
});
